import React from "react";
import { motion } from "framer-motion";
import { Star, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { myriadeColors } from "./data";

const FinalCTA = () => {
    const navigate = useNavigate();

    return (
        <section className="relative py-40 overflow-hidden">
            {/* Animated centerpiece */}
            <div className="absolute top-1/1 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-blue-500/5 rounded-full blur-3xl" />

            {/* Animated particles */}
            <div className="absolute inset-0 overflow-hidden">
                {[...Array(10)].map((_, i) => (
                    <motion.div
                        key={i}
                        className="absolute w-2 h-2 bg-purple-400/20 rounded-full"
                        animate={{
                            y: [0, -100, 0],
                            x: [0, Math.random() * 50 - 25, 0],
                        }}
                        transition={{
                            duration: 4 + Math.random() * 3,
                            repeat: Infinity,
                            delay: i * 0.5
                        }}
                        style={{
                            left: `${Math.random() * 100}%`,
                            top: `${Math.random() * 100}%`,
                        }}
                    />
                ))}
            </div>

            <div className="relative z-10 max-w-4xl mx-auto px-4 text-center">


                <motion.h2
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    className="text-4xl sm:text-5xl md:text-7xl font-bold text-white mb-6 md:mb-8"
                >
                    Prêt à<span className="bg-gradient-to-r from-blue-400 via-cyan-300 to-blue-600 bg-clip-text text-transparent px-2 sm:px-4">transformer</span>votre entreprise ?
                </motion.h2>

                <motion.p
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.2 }}
                    className="text-lg md:text-2xl text-gray-300 mb-10 md:mb-12 px-4"
                >
                    Découvrez comment nos solutions peuvent propulser votre croissance digitale
                </motion.p>

                <motion.button
                    whileHover={{
                        scale: 1.05,
                        y: -3,
                        transition: { duration: 0.2 }
                    }}
                    whileTap={{ scale: 0.98 }}
                    onClick={() => navigate("/Contact")}
                    className="group relative text-white cursor-pointer px-6 py-4 md:px-12 md:py-5 rounded-xl md:rounded-2xl text-[14px] md:text-xl font-bold shadow-lg transition-all duration-300 overflow-hidden mx-auto"
                    style={{
                        background: `linear-gradient(135deg, ${myriadeColors.gradientBlue[0]}, ${myriadeColors.blue})`,
                        boxShadow: `0 20px 40px ${myriadeColors.blue}25`
                    }}
                >
                    {/* Shimmer effect on hover */}
                    <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000" />

                    {/* Halo effect */}
                    <div className="absolute -inset-4 rounded-3xl blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"
                        style={{
                            background: `linear-gradient(135deg, ${myriadeColors.yellow}20, ${myriadeColors.red}20)`
                        }} />

                    {/* Button content */}
                    <span className="relative flex items-center justify-center gap-2">
                        {/* Animated icon */}
                        <motion.div
                            whileHover={{ rotate: 15 }}
                            className="relative"
                        >
                            <div className="absolute -inset-3 bg-white/20 rounded-full blur-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                            <Star className="w-4 h-4 md:w-6 md:h-6 group-hover:scale-110 transition-transform duration-300" />
                        </motion.div>

                        {/* Text with swap animation */}
                        <div className="relative overflow-hidden">
                            <span className="inline-block  transition-transform duration-300 group-hover:-translate-y-full">
                                Discutons de votre projet
                            </span>
                            <span className="absolute left-0 top-0 inline-block w-full text-center  transition-transform duration-300 translate-y-full group-hover:translate-y-0">
                                Contactez-nous maintenant
                            </span>
                        </div>

                        {/* Animated arrow */}
                        <motion.div
                            animate={{ x: [0, 5, 0] }}
                            transition={{ duration: 2, repeat: Infinity }}
                        // className="ml-2"
                        >
                            <ArrowRight className="w-4 h-4 md:w-6 md:h-6 group-hover:translate-x-2 transition-transform duration-300" />
                        </motion.div>
                    </span>

                    {/* Decorative dots */}
                    <div className="absolute -top-2 -right-2 w-4 h-4 rounded-full bg-white/30 blur-sm" />
                    <div className="absolute -bottom-2 -left-2 w-3 h-3 rounded-full bg-white/20 blur-sm" />
                </motion.button>
            </div>
        </section>
    );
};

export default FinalCTA;
